
import {
    ADD_SERVER_CATEGORIES_FORM_NAME,
    serverCategories_getRoutePathStringForForNavigationContainer
} from "./shared";

// framework
import React from "react";
import {connect} from "react-redux";
import {
    compose,
    withHandlers,
    lifecycle
} from "recompose";

// libraries
import {map, isEmpty, find, forEach} from "lodash";

// graphical elements
import { Button } from "react-md";
import {reduxForm, Field, FieldArray} from "redux-form";
import * as Validation from "../../../components/form/Validation";
import SelectField from "../../../components/form/SelectField";
import {setDialog} from "../../../actions/dialogActions";
import {InfoBox, InfoBox_Field, InfoBox_TextField} from "../../../AtollonTheme/ReactElements";
import Header from "../../../components/ContainerHeader";

// redux actions
import {setActiveForm} from "../../../actions/appActions";
import {
    getPerson,
    getOrganizationUserDetail,
    setOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser,
    getUserOrganizations,
    getServerCategories,
    getOrganizationsWithoutRelationRole,
    getHostCategories,
    addServerCategory,
    editHostCategory
} from "../../../actions/resourceActions";
import {} from "../../../actions/requestActions";

import TextField from "../../../components/form/TextField";

// my libs
import * as workInProgress from "../../messages/UserMessages";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import {array_utilities} from "../../utilities/array_utilities";
import {XMLEditor} from "../../utilities/XmlEditor";
import {DebugElement} from "../../debug";
import {
    getAvailablePackageListForAtollonInstance
} from "../../../actions/organizationActions";


let getOrganizationsForForm = ( state ) =>
{
    let { resource: { organizations }} = state;
    let menuItems = [];
    if( !isEmpty( organizations ))
    {
        let organizationItems = organizations.item;
        let sorted = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( organizationItems, ['name'] );
        forEach( sorted, item => {
            menuItems.push({
                label: item.name,
                value: item.identifier
            });
        });
        console.log( "QQQ", {organizations, sorted, menuItems});
    }
    return menuItems;

};

let getInstacesForForm = ( userOrganizationsAll ) =>
{
    let menuItems = [];
    let sortedInstances = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( userOrganizationsAll, ['name'] );

    forEach( sortedInstances, item => {
        menuItems.push({
            label: item.name,
            value: item.id
        });
    });

    console.log( "QQQ", {userOrganizationsAll, sortedInstances, menuItems});

    return menuItems;
};

let getServerCategoryForForm = ( state ) =>
{
    let menuItems = [];
    let { resource: { serverCategories }} = state;
    forEach( serverCategories, item => {
        menuItems.push({
            label: item.name + ' (' + item.shortcut + ')',
            value: item.id
        });
    });
    console.log( "SSS", {serverCategories, menuItems});

    return menuItems;
};

let getPackagesForForm = ( state ) =>
{
    let { resource: { productsByOrganization }} = state;
    let menuItems = [];

    if ( productsByOrganization && productsByOrganization.default)
    {
        forEach( productsByOrganization.default, item => {
            menuItems.push({
                label: item.description + " (" + item.name + ")",
                value: item.name
            });
        });
    }
    console.log( "SSS", {productsByOrganization, menuItems });
    return menuItems;
};

const ServerCategories_Add_and_Edit_AsReact = ( reactStateAndProps ) => {

    let {
        state: {
            app: {
                form: {
                    activeForm
                }
            },
            resource: {
                // person,
                // organizationUserDetails,
                // organizationUsers,
                // organizationUsersAdmin,
                // organizationUsersOwner,
                // organizationUsersUser,
                // productsByOrganization,
                userOrganizationsAll,
                // serverCategories
            }
        },
        // location,
        setActiveForm,
        // initialValues,
        commonTitle,
        // instanceUser,
        ServerCategories_id,
        handleSubmit,
        history,
    } = reactStateAndProps;

    let serverCategory_menuItems = getServerCategoryForForm( reactStateAndProps.state );
    let instanceId_menuItems  = getInstacesForForm( userOrganizationsAll );
    let organizationId_menuItems  = getOrganizationsForForm( reactStateAndProps.state );
    let packageId_menuItems  = getPackagesForForm( reactStateAndProps.state );

    let isAdding = activeForm === ADD_SERVER_CATEGORIES_FORM_NAME;
    let isEditing = ServerCategories_id;

    if( isAdding || isEditing )
    {
        return(
            <div>

                <Header title={commonTitle} />

                <InfoBox>

                    <h1>{isEditing? 'Úprava kategorie':'Přidání kategorie'}</h1>

                    <form  onSubmit={handleSubmit} className="">

                        {isEditing? (
                                <InfoBox_TextField
                                    name={"id"}
                                    value={ServerCategories_id}
                                /> )
                            : null
                        }

                        <Field
                            component={TextField}
                            label={Translate("Název","Název")}
                            name={"name"}
                            menuItems={organizationId_menuItems}
                            validate={[Validation.required]}
                        />

                        <Field
                            component={TextField}
                            label={Translate("shortcut","shortcut")}
                            name={"shortcut"}
                            menuItems={organizationId_menuItems}
                            validate={[Validation.required]}
                        />

                        {/*
                        <Field
                            component={SelectField}
                            label={Translate("Balíček","Balíček")}
                            name={"packageId"}
                            menuItems={packageId_menuItems}
                            validate={[Validation.required]}
                        />
                        */}

                        <br />
                        <br />
                        <br />

                        <Button
                            raised
                            className="btn"
                            label="Zrušit editaci"
                            onClick={() => {
                                if( isEditing )
                                {
                                    history.push( serverCategories_getRoutePathStringForForNavigationContainer() );
                                }
                                else
                                {
                                    setActiveForm(null);
                                }
                            }}
                        />

                        <Button
                            type="submit"
                            primary
                            raised
                            className="btn btn-primary"
                            label={isAdding? "Přidat": "Uložit"}
                        />

                    </form>
                </InfoBox>
            </div>
        );
    }
    else
    {
        return (
            <DebugElement text={"InstanceUserDetail -- PASS"}/>
        );
    }
};


/**
 *
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 *
 *
 */

export const ServerCategories_Add_and_Edit_AsRedux = (compose(
    connect(
        (state) => {return {state}},
        {
            getPerson,
            getOrganizationUserDetail,
            getOrganizationUsers,
            getOrganizationUsersAdmin,
            getOrganizationUsersOwner,
            getOrganizationUsersUser,
            setDialog,
            setActiveForm,
            setOrganizationUserDetail,
            getAvailablePackageListForAtollonInstance,
            getServerCategories,
            getUserOrganizations,
            getOrganizationsWithoutRelationRole,
            //
            editHostCategory,
            addServerCategory
        }
    ),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) => {

            let {
                addServerCategory,
                getServerCategories,
                editHostCategory,
                state
            } = props;

            let addParameters = {};


            addParameters.name = formData.name;
            addParameters.shortcut = formData.shortcut;

            if( formData.id )
            {
                // alert('Není implementováno')
                // // isEditing
                //
                addParameters.id = formData.id;

                let ok = await addServerCategory( addParameters );
                if( ok )
                {
                    await getServerCategories();
                    workInProgress.userMessage_ok("Kategorie upravena");
                }
            }
            else
            {
                // isAdding

                let ok = await addServerCategory( addParameters );
                if( ok )
                {
                    await getServerCategories();
                    workInProgress.userMessage_ok("Kategorie přidána");
                }
            }


        }
    }),
    lifecycle({
        componentWillMount()
        {
            let {
                getServerCategories
            } = this.props;

            getServerCategories();
        }
    }),
    reduxForm({
        form: ADD_SERVER_CATEGORIES_FORM_NAME,
        enableReinitialize: true
    })
)(ServerCategories_Add_and_Edit_AsReact));



// WEBPACK FOOTER //
// ./src/Atollon/pages/ServerCategories/ServerCategories_Add_and_Edit.js